import { IconComponent } from "@flixbus/honeycomb-icons-react";
import * as React from "react";

export type SelectOption = {
  value: string;
  label: string;
  suffixElement?: React.JSX.Element;
  icon?: React.JSX.Element;
  description?: string;
  isDisabled?: boolean;
  multiIconLabel?: Array<{ icon: IconComponent; label: number }>;
};
